<template>
    <component
        v-if="integration"
        :is="formName"
        :id="id"
        :integration="integration"
        :configuration="configuration"/>
    <v-no-content v-else-if="serverError" img-src="">
        <template #title>
            Integration Error
        </template>
        <template #description>
            Unable to load this integration at this time. Please try again later or contact support.
        </template>
        <template #actions>
            <router-link
                class="btn btn-primary" :to="{name: 'integrations'}">
                Return to integrations
            </router-link>
        </template>
    </v-no-content>
</template>

<script>
    import IntegrationModel from '@/common/models/integration-model';
    import IntegrationsConfigurationsModel from '@/common/models/integrations-configurations-model';
    import FormLoaderMixin from '@/mixins/form-loader-mixin';
    import vNoContent from '@/components/v-no-content';

    const forms = Object.values(IntegrationModel.Services).reduce(
        (result, service) => {
            result[`${service}-form`] = () => import(`./${service}/${service}-form.vue`);
            return result;
        },
        {vNoContent},
    );

    export default {
        mixins: [FormLoaderMixin],
        components: forms,
        props: {
            service: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                integration: null,
                configuration: null,
                serverError: false,
            };
        },
        computed: {
            formName() {
                return `${this.service}-form`;
            },
            predicate() {
                // override mixin to always require fetchData to run
                return true;
            },
        },
        methods: {
            async fetchData() {
                try {
                    const {fields} = await this.$api(({integrations}) => integrations.get({service: this.service}));
                    this.integration = new IntegrationModel(fields);

                    if (this.id) {
                        this.configuration = IntegrationsConfigurationsModel.restoreById(this.id);
                    }
                } catch (error) {
                    this.$toast.fromError(error);
                    this.serverError = true;
                }
            },
        },
    };
</script>
